import { FaTwitter, FaInstagram, FaLinkedin, FaDiscord } from 'react-icons/fa'
import { StyledSocialIcons } from './SocialIcons.styled'

export default function SocialIcons() {
  return (
    <StyledSocialIcons>
      <li>
        <a href='https://discord.gg/a3N5ptfXR5' target="_blank" rel="noreferrer" >
          <FaDiscord />
        </a>
      </li>      
      <li>
        <a href='https://twitter.com/RaidhiveT' target="_blank" rel="noreferrer" >
          <FaTwitter />
        </a>
      </li>      
      <li>
        <a href='https://www.linkedin.com/company/raidhive/' target="_blank" rel="noreferrer" >
          <FaLinkedin />
        </a>
      </li>
      <li>
        <a href='https://www.instagram.com/raidhiveteam/' target="_blank" rel="noreferrer" >
          <FaInstagram />
        </a>
      </li>
    </StyledSocialIcons>
  )
}
